import { render, staticRenderFns } from "./Service.vue?vue&type=template&id=49d76946&"
import script from "./Service.vue?vue&type=script&scoped=true&lang=js&"
export * from "./Service.vue?vue&type=script&scoped=true&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports